export const initBroadcastChannel = (channelName) => {
    return new BroadcastChannel(channelName);
};

export const handleBroadcastMessage = (channel, clearAuthState) => {
    if (channel) {
        channel.onmessage = (event) => {
            if (event.data === "LOGOUT") {
                // console.log("Logout event received. Logging out all tabs.");
                clearAuthState();
                window.location.href = "/";
            }
        };
    }
};

export const closeBroadcastChannel = (channelRef) => {
    if (channelRef.current) {
        channelRef.current.close();
        channelRef.current = null;
    }
};
